import React from 'react'
import TransactionFees from './TransactionFees/TransactionFees'
import AdvertisingFees from './AdvertisingFees/AdvertisingFees'
import FulfillmentFees from './FulfillmentFees/FulfillmentFees'
import OtherCharges from './OtherCharges/OtherCharges'

const PricingFeeStructure = () => {
  
  return (
    <section className='px-3 py-2'>
      
      <TransactionFees />

      <AdvertisingFees />

      <FulfillmentFees />

      <OtherCharges />
    </section>
  )
}

export default PricingFeeStructure
